export default {
    data(){
        return{
    en: {
      
      /* ===================== INDUSTRY AREA ======================*/

      industry_area_title: "Industry Area",
      industry_area: [
        {
          id: "film_television",
          title: "Film And Television",
          description: "Descriptions",
          image: require('@/assets/img/Homepage/IndustryArea/FilmTelevision.jpg'),
          link: { path: '/planAndCases', hash: '#film_television' }
        },
        {
          id: "digital_assets",
          title: "Digital Assets",
          description: "Descriptions",
          image: require('@/assets/img/Homepage/IndustryArea/DigitalAssets.png'),
          link: { path: '/planAndCases', hash: '#digital_assets' }
        },
        {
          id: "culture_tour",
          title: "Culture Tour",
          description: "Descriptions",
          image: require('@/assets/img/Homepage/IndustryArea/CultureTour.jpg'),
          link: { path: '/planAndCases', hash: '#culture_tour' }
        },
        {
          id: "aigc",
          title: "AIGC",
          description: "Descriptions",
          image: require('@/assets/img/Homepage/IndustryArea/AIGC.png'),
          link: { path: '/planAndCases', hash: '#aigc' }
        }
      ],

      /* ===================== PLAN AND CASES ======================*/

      plan_and_cases_title: "Plan And Cases",
      plan_and_cases_1: [
        {
          p1: "VR Park Fangte Venue",
          p2: "VR Vidámpark’s first family entertainment center in China, also Ningbo Fangte's first international high-tech themed venue.",
          image: require('@/assets/img/Homepage/PlanandCases/OrcaBeat.jpg'),
          link: { path: '/planAndCases/cultureTour/VRParkCasesPage' }
        },
      ],
      plan_and_cases_2: [
        {
          p1: "Virtual Production: Sea of Dreams",
          p2: "Space glaciers, apocalyptic wastelands! Virtual filmmaking technology empowers the visual feast!",
          // p3: "轻风感 满屋凉",
          image: require('@/assets/img/Homepage/PlanandCases/img2.jpg'),
          link: { path: '/planAndCases/filmAndTelevision/DreamWaterPage' }
        },
      ],
      plan_and_cases_345: [
        {
          p1: "BJTU's Digital Museum",
          p2: "Witness the history, feel the future! Such a different museum experience!",
          image: require('@/assets/img/Homepage/PlanandCases/BeijiaoPictureWallOpacity.png'),
          link: { path: '/planAndCases/digitalAssets/BeijiaoDigitalMuseumPage' }
        },
        {
          p1: "Xiangshan Global Studios Light Projection Show",
          p2: "“Tang and Song Wonderful Night” hot open, a brand new tourism!",
          image: require('@/assets/img/Homepage/PlanandCases/XiangshanLightingShow.png'),
          link: { path: '/planAndCases/cultureTour/CityWallProjectionPage' }
        },
        {
          p1: "Meta-Human",
          p2: "Hello! I'm your new friend, MataHuman!",
          image: require('@/assets/img/Homepage/PlanandCases/MetaHumanShangguan.jpg'),
          link: { path: '/planAndCases/AIGC/BataHumanPage' }
        }
      ],

      /* ===================== News ======================*/

      news_title: "News",
      news_1: [
        {
          p1: "Rosy Nebula established cooperative relationship with VR Vidámpark team to expand China's VR theme park market",
          // p2: "Rosy Nebula works with a Hungarian team to launch a VR theme park project",
          image: require('@/assets/img/Homepage/News/VRParkPageWallpaper_homepage_edited.png'),
          link: { path: '/news/008-VRParkPage' }
        },
      ],
      news_2: [
        {
          p1: "Xiangshan Global Studios' Wonderful Night of the Tang and Song Dynasties cultural night tour activity opened hot, Rosy Nebula technical support to help innovative experience",
          //p2: "Rosy Nebula provided supporting technical services for the Wonderful Night of the Tang and Song Dynasties",
          image: require('@/assets/img/Homepage/News/LightShowPageWallpaper_homepage_edited.png'),
          link: { path: '/news/004-LightShowPage' }
        },
        {
          p1: "Central and Eastern Europe Youth Innovation and Entrepreneurship Competition was successfully held in Ningbo -- Rosy Nebula shared the entrepreneurial achievements",
          //p2: "Rosy Nebula shared their entrepreneurial experience at the Innovation and Entrepreneurship Exchange Seminar",
          image: require('@/assets/img/Homepage/News/InnovationEntrepreneurshipPageWallpaper_homepage_edited.png'),
          link: { path: '/news/007-InnovationEntrepreneurshipPage' }
        },
        {
          p1: "Rosy Nebula Information Technology Co., Ltd. was established",
          //p2: "Rosy Nebula, established on June 22, 2022, is committed to creating unique value with technology.",
          image: require('@/assets/img/Homepage/News/Logo_homepage_edited.jpg'),
          link: { path: '/news/001-CompanyEstablishedPage' }
        },
      ],
      
    }
}
}
  };
  